module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "VbSwitchWithTwoLabels is-inline-block"
  }, [_c('span', {
    class: !_vm.checked ? 'active' : '',
    on: {
      "click": function($event) {
        return _vm.setValue(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.labelLeft))]), _vm._v(" "), _c('vb-switch', {
    attrs: {
      "type": "",
      "size": "medium"
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }), _vm._v(" "), _c('span', {
    class: _vm.checked ? 'active' : '',
    on: {
      "click": function($event) {
        return _vm.setValue(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.labelRight))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e5d0768c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/components/VbSwitchWithTwoLabels.vue
// module id = 477
// module chunks = 42